import AddUpgradeRoomFlow from '../AddUpgradeRoomFlow/AddUpgradeRoomFlow';
import {
  ButtonBase,
  PrimaryLink,
  BaseColumnWrap,
} from '../../../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import PaxInfo from '../PaxInfo/PaxInfo';
import {appConfig, gaConfig} from '@stencil/hotels-config';
import * as S from './PWIList.styles';
import {getSlashAndShowPriceCg} from '@stencil/hotels-utils/src/get-details-slash-and-show-price';

export default function PWIList({
  pwiDataItem,
  index,
  roomPriceCode,
  roomTypeCode,
  supplierCode,
  onRoomCountUpdate = (key, data, index) => {},
}) {
  const {rupeeString} = appConfig;

  const {slashedPrice, showPrice, priceDisplayMsg, tnc} = getSlashAndShowPriceCg(pwiDataItem);
  return (
    <>
      <S.PaxDetailsDiv>
        <BaseColumnWrap>
          <PaxInfo
            adultCount={pwiDataItem?.occupancydetails?.numberOfAdults}
            childCount={pwiDataItem?.occupancydetails?.numberOfChildren}
            showCountTextBelow={true}
          />
        </BaseColumnWrap>

        <S.PricingWrapper>
          {slashedPrice && showPrice && showPrice !== slashedPrice ? (
            <S.StrickedpriceSpan>
              {rupeeString} {slashedPrice}
            </S.StrickedpriceSpan>
          ) : null}

          <S.OriginalpriceSpan>
            {rupeeString} {showPrice}
          </S.OriginalpriceSpan>
          {!!tnc && (
            <S.TaxpriceSpan>
              + {rupeeString} {tnc} taxes & fees
            </S.TaxpriceSpan>
          )}
        </S.PricingWrapper>
      </S.PaxDetailsDiv>
      <S.PaxAdditionDiv>
        <AddUpgradeRoomFlow
          index={index}
          rpc={roomPriceCode}
          rtc={roomTypeCode}
          pk={pwiDataItem?.pk}
          pax={pwiDataItem?.pd?.pax}
          pwiDataItem={pwiDataItem}
          supplierCode={supplierCode}
          onRoomCountUpdate={onRoomCountUpdate}
        />
      </S.PaxAdditionDiv>
    </>
  );
}
